const stripeErrorMessages: Record<string, string> = {
  card_declined: 'Your card was declined. Please try another card.',
  incorrect_number: 'The card number is incorrect.',
  expired_card: 'The card has expired.',
  insufficient_funds: 'The card has insufficient funds.'
};

export function mapStripeError(error: {
  code?: string;
  message?: string;
}): string {
  return (
    (error.code && stripeErrorMessages[error.code]) ??
    error.message ??
    'Payment method validation failed.'
  );
}
